module.exports = __webpack_public_path__ + "static/media/0030.6c5d9e3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48107/Chassis_RAL/0030.png
// module id = 2612
// module chunks = 0